import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
    fonts: {
        heading: 'Inter, sans-serif',
        body: 'Inter, sans-serif',
    },
    colors: {
        'Kitron': {
            DarkGrey: '#4A4A4A',
            LightGrey: '#636466',
            Blue: '#004990',
            LightBlue: '#DFEEF9',
            Orange: '#FF8400',
            Red: '#CC0000',
            Warning: '#CC0000',
            Danger: '#750000',
            White: '#FFFFFF',
            Background: '#F2F6F9',
            BackgroundAlt: '#2A348C0D',
            Purple: '#660199',
            Primary: '#004990',
        },
    },
    components: {
        Button: {
            variants: {
                'Primary': {
                    background: 'Kitron.Blue',
                    color: 'Kitron.White',
                    border: '1px solid',
                    borderColor: 'Kitron.White',
                    _hover: {
                        background: 'Kitron.Orange',
                        color: 'Kitron.White',
                        borderColor: 'Kitron.Orange',
                    },
                },
                'Secondary': {
                    background: 'Kitron.White',
                    color: 'Kitron.Blue',
                    border: '1px solid',
                    borderColor: 'Kitron.Blue',
                    _hover: {
                        background: 'Kitron.Orange',
                        color: 'Kitron.White',
                        borderColor: 'Kitron.Orange',
                    },
                },
                'Warning': {
                    background: 'Kitron.Warning',
                    color: 'Kitron.White',
                    border: '1px solid',
                    borderColor: 'Kitron.White',
                    _hover: {
                        background: 'Kitron.Orange',
                        color: 'Kitron.White',
                        borderColor: 'Kitron.Orange',
                    },
                },
            },
        },
        Link: {
            variants: {
                'isActive': {
                    fontWeight: 800,
                    color: 'Kitron.Blue',
                },
            },
        },
        Heading: {
            baseStyle: {
                fontWeight: 600,
            },
        },
        Checkbox: {
            baseStyle: {
                control: {
                    bg: 'Kitron.BackgroundAlt',
                    borderColor: 'Kitron.Blue',
                    borderWidth: 1,
                },
            },
            defaultProps: {
                size: 'lg',
                colorScheme: 'Kitron.Primary',
            },
        },
    },
});
